/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-01T16:33:48.746
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentFacility,
	listRentFacilityInit,
	listRentFacilityByAuthorizations,
	deleteRentFacility
	
} from '@api/rentmanage/RentFacility';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentFacility({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentFacility(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentFacilityByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentFacilityByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentFacilityInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentFacilityInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentFacility({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentFacility({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
